import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'store/hooks';

import { getCourseById, getDailyChallengeForEditor } from 'store/course/actions';
import { getLessonById } from 'store/lesson/actions';

import { currentLessonSelector } from 'store/lesson/selectors';

import LessonPreviewProvider from './LessonPreviewProvider';

const LessonPreviewProviderContainer = () => {
  const { courseId, lessonId } = useParams();
  const { pathname } = useLocation();

  const isDailyChallengeLesson = pathname.startsWith('/daily-challenges/');

  const dispatch = useAppDispatch();

  const lesson = useSelector(currentLessonSelector);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    Promise.all([
      dispatch(
        isDailyChallengeLesson
          ? getDailyChallengeForEditor(courseId)
          : getCourseById(courseId),
      ),
      dispatch(getLessonById({ courseId, lessonId })),
    ]).finally(() => {
      setLoading(false);
    });
  }, [lessonId]);

  return <LessonPreviewProvider loading={loading} lesson={lesson} />;
};

export default React.memo(LessonPreviewProviderContainer);
